export enum TransactionType {
    withdrawal = 'Withdrawal',
    topup = 'Top Up',
    adjustment = 'Adjustment',
    invest = 'Investment'
}